import React, { useEffect, useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { Outlet, useNavigate } from 'react-router-dom';
import { obterLimiteEmprestimoRequest } from '../../../../store/modules/emprestimo/actions';

export const SimularContratar = () => {
  const navigate = useNavigate();
  const dispatch = useDispatch();
  const { matricula, token } = useSelector((state) => state.user);
  const [dtParcelas, setDtParcelas] = useState({});
  const [dadosBancarios, setDadosBancarios] = useState({});

  useEffect(() => {
    dispatch(
      obterLimiteEmprestimoRequest({
        matricula,
        token,
      })
    );
  }, [dispatch, matricula, token]);

  const nextState = (url, dtparcelas, dadosbancarios) => {
    setDtParcelas(dtparcelas);
    setDadosBancarios(dadosbancarios);
    navigate(url);
  };

  const previousState = (url) => {
    navigate(url);
  };

  return (
    <Outlet
      context={{
        onNext: nextState,
        onBack: previousState,
        dtParcelas,
        dadosBancarios,
      }}
    />
  );
};
